import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { ScopeFilters } from './scope-filters.model';

@Injectable()
export class ScopeFiltersService {
  constructor(private http: HttpClient) {}
}
